module.exports = __webpack_public_path__ + "img/rockettubes_inst_front.4b04d2ee.png";